import { create } from "zustand";
import { MenuPrivilegeStoreProps } from "../types/menu-privilege.type";
import menuPrivilegeService from "../services/menu-privilege.service";

const menuPrivilegeStore = create<MenuPrivilegeStoreProps>((set) => ({
  // Loading
  loading: true,
  setLoading: (loading) => set((state) => ({
    ...state,
    loading,
  })),
  toggleLoading: () => set((state) => ({
    ...state,
    loading: !state.loading,
  })),

  // Error
  error: false,
  setError: (error) => set((state) => ({
    ...state,
    error,
  })),
  toggleError: () => set((state) => ({
    ...state,
    error: !state.error,
  })),
  errorMessage: '',
  setErrorMessage: (errorMessage) => set((state) => ({
    ...state,
    errorMessage
  })),

  // Privilege data
  privilege: [],
  setPrivilege: (newPrivilege) => set((state) => ({
    ...state,
    privilege: newPrivilege,
  })),
  fetchPrivilege: async () => {
    set((state) => ({ 
      ...state, 
      loading: true, 
    }))
    const response = await menuPrivilegeService.list({})
    if (response.code !== '200') {
      localStorage.clear()
      return
    }
    set((state) => ({ 
      ...state, 
      error: false, 
      loading: false, 
      errorMessage: '',
      privilege: response.data
    }))
  }
}))

export default menuPrivilegeStore